import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";

import { jqxGridModule } from "jqwidgets-ng/jqxgrid";
import { jqxInputModule } from "jqwidgets-ng/jqxinput";
import { jqxWindowModule } from "jqwidgets-ng/jqxwindow";
import { jqxLoaderModule } from "jqwidgets-ng/jqxloader";
import { jqxButtonModule } from "jqwidgets-ng/jqxbuttons";
import { jqxDateTimeInputModule } from "jqwidgets-ng/jqxdatetimeinput";
import { jqxDropDownButtonModule } from "jqwidgets-ng/jqxdropdownbutton";

import { InputNumberModule } from "../input-number/input-number.module";
import { LabelOverLenghtModule } from "../label-over-lenght/label-over-lenght.module";

import { ConfiguracionCerradurasComponent } from "./configuracion-cerraduras.component";
import { ConfiguracionCerradurasEditComponent } from "./configuracion-cerraduras-edit/configuracion-cerraduras-edit.component";
import { ConfiguracionCerraduraAsignarComponent } from './configuracion-cerradura-asignar/configuracion-cerradura-asignar.component';

@NgModule({
  declarations: [
    ConfiguracionCerradurasComponent,
    ConfiguracionCerradurasEditComponent,
    ConfiguracionCerraduraAsignarComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    jqxGridModule,
    jqxInputModule,
    jqxLoaderModule,
    jqxWindowModule,
    jqxButtonModule,
    InputNumberModule,
    LabelOverLenghtModule,
    jqxDateTimeInputModule,
    jqxDropDownButtonModule,
  ],
  exports: [
    ConfiguracionCerradurasComponent
  ]
})
export class ConfiguracionCerraduraModule { }
